import { createIcon } from '../createIcon';
import { ReactComponent as IconExclamationSquare } from '../svg/exclamation-square.svg';

export default createIcon(IconExclamationSquare);
